import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Preferir env vars, com fallback para valores existentes (transição)
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://dzvzrbuotqitkikmbbos.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR6dnpyYnVvdHFpdGtpa21iYm9zIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY2MTMzOTMsImV4cCI6MjA3MjE4OTM5M30.u0VzoJYbRFGuNnyhR531fNGukcGHtSI5pepHhzBGuKo";

// SINGLETON: Garantir uma única instância do Supabase client
let supabaseSingleton: ReturnType<typeof createClient<Database>> | null = null;

export function getSupabase() {
  if (!supabaseSingleton) {
    supabaseSingleton = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
      auth: {
        storage: localStorage,
        persistSession: true,
        autoRefreshToken: true,
      }
    });
  }
  return supabaseSingleton;
}

export const supabase = getSupabase();